<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area invest04">
      <div class="tit_area">
        <div class="sub_tit">공고</div>
        <div class="sub_txt">주요 경영사항을 공고합니다.</div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <div class="flex_box">
        <h3>공고</h3>

        <div class="selectbox3 vselect ty_wid">
          <v-select v-model="year" :options="options" :searchable="false">
          </v-select>
        </div>
      </div>
      <div class="tbl_ty01 bod">
        <table>
          <caption>
            공시:구분,등록일,관련자료로 구성
          </caption>
          <colgroup>
            <col style="width: auto" />
            <col style="width: 20%" />
            <col style="width: 20%" />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">구분</th>
              <th scope="col">등록일</th>
              <th scope="col">관련자료</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in listItems" :key="`inverst-tr-${idx}`">
              <td class="aLeft">
                {{ item.title }}
              </td>
              <td class="aCenter">{{ item.reg_date }}</td>
              <td class="aCenter">
                <a
                  class="btn_line"
                  :title="item.file_oriname"
                  href="#"
                  @click.prevent="download(item.seq)"
                  >내용보기</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- paging -->
      <div class="paging_item">
        <div class="btn_area">
          <a
            href="#"
            :class="['btn_first', { inactive: isFirst }]"
            @click.prevent="firstPage($event)"
            >첫페이지</a
          >
          <a
            href="#"
            :class="['btn_prev', { inactive: isFirst }]"
            @click.prevent="prevPage($event)"
            >이전</a
          >
        </div>
        <div class="paging">
          <a
            v-for="(item, idx) in viewPageLength"
            :class="{ active: isCurrent(idx) }"
            :key="`paging-atag-${idx}`"
            href="#"
            @click.prevent="changePage(showPageLabel(idx) - 1)"
            >{{ showPageLabel(idx) }}</a
          >
        </div>
        <div class="btn_area">
          <a
            href="#"
            :class="['btn_next', { inactive: isLast }]"
            @click.prevent="nextPage($event)"
            >다음</a
          >
          <a
            href="#"
            :class="['btn_last', { inactive: isLast }]"
            @click.prevent="lastPage($event)"
            >마지막페이지</a
          >
        </div>
      </div>
      <!-- paging -->
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>
<script>
import invest021 from './p_invest021';

export default invest021;
</script>

<style lang="scss" scoped></style>
